// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* justify-content: center; */
    height: auto; /* Allow height to adjust */
    min-height: 100vh; /* Ensure it fills the viewport */
    background-color: #f5f5f5; /* Light background */
    padding: 20px;
    overflow: auto; /* Allow scrolling if content overflows */
    justify-content:flex-start;
}

h11 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 10px;
    height: auto;
    position:auto;
}

p1 {
    font-size: 1.2rem;
    color: #555;
    margin-bottom: 20px;
    height: auto;
    position:auto;
}

button1 {
    padding: 10px 20px;
    font-size: 1rem;
    color: white;
    background-color: #007bff; /* Blue color */
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
    margin-bottom: 5px;
    height: auto;
    position:auto;
}

button:hover {
    background-color: #0056b3; /* Darker blue on hover */
}

.scrollable-table {
    overflow-x: auto; /* Allow horizontal scrolling */
    max-width: 100%; /* Ensure it fits within the container */
}

.matrix-table {
    margin-top: 20px;
    border-collapse: collapse;
    width: 100%; /* Use full width for responsiveness */
    max-width: 800px; /* Set a maximum width for the table */
    /* table-layout: auto; Allow columns to adjust based on content */
}

.matrix-table th, .matrix-table td {
    border: 2px solid #007bff; /* Border color */
    text-align: center;
    padding: 15px; /* Increase padding for better readability */
    overflow: visible; /* Allow content to be visible */
    text-overflow: clip; /* Remove ellipsis for clarity */
    white-space: normal; /* Allow text wrapping */
}

.matrix-table th {
    font-size: 1.2rem; /* Increase header font size */
    background-color: #007bff; /* Header background color */
    color: white; /* Header text color */
}

.matrix-table td {
    font-size: 1rem; /* Increase cell font size */
}

.matrix-table td:before {
    content: none !important; 
  }



.matrix-table tr:nth-child(even) {
    background-color: #e9f1ff; /* Light blue for even rows */
}

.matrix-table tr:nth-child(odd) {
    background-color: #ffffff; /* White for odd rows */
}
`, "",{"version":3,"sources":["webpack://./src/Components/StatsPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY,EAAE,2BAA2B;IACzC,iBAAiB,EAAE,iCAAiC;IACpD,yBAAyB,EAAE,qBAAqB;IAChD,aAAa;IACb,cAAc,EAAE,yCAAyC;IACzD,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yBAAyB,EAAE,eAAe;IAC1C,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,yBAAyB,EAAE,yBAAyB;AACxD;;AAEA;IACI,gBAAgB,EAAE,+BAA+B;IACjD,eAAe,EAAE,wCAAwC;AAC7D;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,WAAW,EAAE,sCAAsC;IACnD,gBAAgB,EAAE,sCAAsC;IACxD,iEAAiE;AACrE;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,kBAAkB;IAClB,aAAa,EAAE,4CAA4C;IAC3D,iBAAiB,EAAE,gCAAgC;IACnD,mBAAmB,EAAE,gCAAgC;IACrD,mBAAmB,EAAE,wBAAwB;AACjD;;AAEA;IACI,iBAAiB,EAAE,8BAA8B;IACjD,yBAAyB,EAAE,4BAA4B;IACvD,YAAY,EAAE,sBAAsB;AACxC;;AAEA;IACI,eAAe,EAAE,4BAA4B;AACjD;;AAEA;IACI,wBAAwB;EAC1B;;;;AAIF;IACI,yBAAyB,EAAE,6BAA6B;AAC5D;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;AACtD","sourcesContent":[".stats-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    /* justify-content: center; */\r\n    height: auto; /* Allow height to adjust */\r\n    min-height: 100vh; /* Ensure it fills the viewport */\r\n    background-color: #f5f5f5; /* Light background */\r\n    padding: 20px;\r\n    overflow: auto; /* Allow scrolling if content overflows */\r\n    justify-content:flex-start;\r\n}\r\n\r\nh11 {\r\n    font-size: 2.5rem;\r\n    color: #333;\r\n    margin-bottom: 10px;\r\n    height: auto;\r\n    position:auto;\r\n}\r\n\r\np1 {\r\n    font-size: 1.2rem;\r\n    color: #555;\r\n    margin-bottom: 20px;\r\n    height: auto;\r\n    position:auto;\r\n}\r\n\r\nbutton1 {\r\n    padding: 10px 20px;\r\n    font-size: 1rem;\r\n    color: white;\r\n    background-color: #007bff; /* Blue color */\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s;\r\n    margin-bottom: 5px;\r\n    height: auto;\r\n    position:auto;\r\n}\r\n\r\nbutton:hover {\r\n    background-color: #0056b3; /* Darker blue on hover */\r\n}\r\n\r\n.scrollable-table {\r\n    overflow-x: auto; /* Allow horizontal scrolling */\r\n    max-width: 100%; /* Ensure it fits within the container */\r\n}\r\n\r\n.matrix-table {\r\n    margin-top: 20px;\r\n    border-collapse: collapse;\r\n    width: 100%; /* Use full width for responsiveness */\r\n    max-width: 800px; /* Set a maximum width for the table */\r\n    /* table-layout: auto; Allow columns to adjust based on content */\r\n}\r\n\r\n.matrix-table th, .matrix-table td {\r\n    border: 2px solid #007bff; /* Border color */\r\n    text-align: center;\r\n    padding: 15px; /* Increase padding for better readability */\r\n    overflow: visible; /* Allow content to be visible */\r\n    text-overflow: clip; /* Remove ellipsis for clarity */\r\n    white-space: normal; /* Allow text wrapping */\r\n}\r\n\r\n.matrix-table th {\r\n    font-size: 1.2rem; /* Increase header font size */\r\n    background-color: #007bff; /* Header background color */\r\n    color: white; /* Header text color */\r\n}\r\n\r\n.matrix-table td {\r\n    font-size: 1rem; /* Increase cell font size */\r\n}\r\n\r\n.matrix-table td:before {\r\n    content: none !important; \r\n  }\r\n\r\n\r\n\r\n.matrix-table tr:nth-child(even) {\r\n    background-color: #e9f1ff; /* Light blue for even rows */\r\n}\r\n\r\n.matrix-table tr:nth-child(odd) {\r\n    background-color: #ffffff; /* White for odd rows */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
